import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

const FIELDS = [
  { name: "whatsapp", label: "WhatsApp number (digits only, country code first)", ph: "917290046341" },
  { name: "phone", label: "Phone (display format)", ph: "+91 72900 46341" },
  { name: "email", label: "Contact email", ph: "travels@acchajeemail.com" },
  { name: "address", label: "Office address", ph: "Mile Stone, 1/2, Khandsa Rd, Sector 37, Gurugram, Haryana 122004", textarea: true },
  { name: "hours", label: "Working hours", ph: "Mon–Sat: 10:00 AM – 6:00 PM" },
  { name: "tagline", label: "Brand tagline", ph: "Explore. Experience. Elevate." },
  { name: "map_embed", label: "Google Maps embed URL (iframe src)", ph: "https://www.google.com/maps/embed?pb=…", textarea: true },
];

export default function SettingsForm() {
  const [f, setF] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get("/admin/settings").then(r => setF(r.data || {})).finally(() => setLoading(false));
  }, []);

  const onChange = (e) => setF({ ...f, [e.target.name]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = Object.fromEntries(Object.entries(f).filter(([_, v]) => v !== undefined && v !== ""));
      await api.put("/admin/settings", payload);
      toast.success("Settings saved — public site updated instantly");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="muted">Loading settings…</div>;

  const input = "w-full px-4 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#006CE4] focus:ring-4 focus:ring-blue-100 transition";

  return (
    <form onSubmit={save} className="card-glass p-6 space-y-4 max-w-3xl" data-testid="settings-form">
      <div className="pb-2 border-b border-slate-100">
        <h3 className="h3">Site Settings</h3>
        <p className="muted text-sm mt-1">These update your public Contact page, footer, floating buttons, and emails instantly.</p>
      </div>
      {FIELDS.map((fld) => (
        <div key={fld.name}>
          <label className="text-xs font-semibold muted">{fld.label}</label>
          {fld.textarea ? (
            <textarea name={fld.name} value={f[fld.name] || ""} onChange={onChange} rows={fld.name === "map_embed" ? 3 : 2} className={`${input} resize-none mt-1`} placeholder={fld.ph} data-testid={`settings-${fld.name}`} />
          ) : (
            <input name={fld.name} value={f[fld.name] || ""} onChange={onChange} className={`${input} mt-1`} placeholder={fld.ph} data-testid={`settings-${fld.name}`} />
          )}
        </div>
      ))}
      <button type="submit" disabled={saving} className="btn-primary disabled:opacity-60" data-testid="settings-save">
        {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />} Save Changes
      </button>
    </form>
  );
}
